import { 
    IDI_INSPECTION_DASHBOARD_START_LOADING, 
    IDI_INSPECTION_DASHBOARD_END_LOADING,
    SET_IDI_INSPECTION_DASHBOARD_FILTER_SEARCH,
    IDI_INSPECTION_DASHBOARD_DRAFT_LOADED, 
    IDI_INSPECTION_DASHBOARD_PENDING_FOR_INSPECTION_LOADED,
    IDI_INSPECTION_DASHBOARD_INSPECTION_IN_PROCESS_LOADED,
    IDI_INSPECTION_DASHBOARD_READY_FOR_REVIEW_LOADED,
    IDI_INSPECTION_DASHBOARD_UPLOAD_TO_TAWUNIYA_LOADED,
    IDI_INSPECTION_DASHBOARD_COMPLETED_LOADED,
    IDI_INSPECTION_DASHBOARD_CLOSED_LOADED,
    IDI_INSPECTION_DASHBOARD_ABORTED_LOADED,
    IDI_INSPECTION_DASHBOARD_USER_SEARCH_LOADED
} from "../constants/IdiInspectionDashboardConstants";

const initialState = {
    loading: false,
    search: "",
    draftList: [],
    pendingForInspectionList: [],
    inspectionInProcessList: [],
    readyForReviewList: [],
    uploadToTawuniyaList: [],
    completedList: [],
    closedList: [],
    abortedList: [],
    searchList: []
};

const IdiInspectionDashboardReducer = (state = initialState, action) => {
    switch(action.type) {
        case IDI_INSPECTION_DASHBOARD_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case IDI_INSPECTION_DASHBOARD_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case SET_IDI_INSPECTION_DASHBOARD_FILTER_SEARCH:
            return {
                ...state,
                search: action.payload
            };
        case IDI_INSPECTION_DASHBOARD_DRAFT_LOADED:
            return {
                ...state,
                draftList: action.payload
            };
        case IDI_INSPECTION_DASHBOARD_PENDING_FOR_INSPECTION_LOADED:
            return {
                ...state,
                pendingForInspectionList: action.payload
            };
        case IDI_INSPECTION_DASHBOARD_INSPECTION_IN_PROCESS_LOADED:
            return {
                ...state,
                inspectionInProcessList: action.payload
            };
        case IDI_INSPECTION_DASHBOARD_READY_FOR_REVIEW_LOADED:
            return {
                ...state,
                readyForReviewList: action.payload
            };
        case IDI_INSPECTION_DASHBOARD_UPLOAD_TO_TAWUNIYA_LOADED:
            return {
                ...state,
                uploadToTawuniyaList: action.payload
            };
        case IDI_INSPECTION_DASHBOARD_COMPLETED_LOADED:
            return {
                ...state,
                completedList: action.payload
            };
        case IDI_INSPECTION_DASHBOARD_CLOSED_LOADED:
            return {
                ...state,
                closedList: action.payload
            };
        case IDI_INSPECTION_DASHBOARD_ABORTED_LOADED:
            return {
                ...state,
                abortedList: action.payload
            };
        case IDI_INSPECTION_DASHBOARD_USER_SEARCH_LOADED:
            return {
                ...state,
                searchList: action.payload
            };
        default:
            return state;
    }
}

export default IdiInspectionDashboardReducer;